import { render, staticRenderFns } from "./AEmpresas.vue?vue&type=template&id=61263c9c"
import script from "./AEmpresas.vue?vue&type=script&lang=js"
export * from "./AEmpresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports